<template>
    <h1>Registrieren</h1>
    <p>
        Um unseren Online-Bestellservice nutzen zu können, füllen Sie bitte folgendes Formular aus.
    </p>
    <p class="subheadline">Wohin dürfen wir liefern?</p>
    <ul>
        <li @click="selectWork()">Auf Arbeit</li>
        <li @click="selectHome()">Nach Hause</li>
        <li @click="selectSchool()">In die Schule</li>
        <li @click="selectKita()">In die Kita</li>
    </ul>
    <Modal v-show="modalVisible">
        <div class="modal-message">
            <p>{{ modalText }}</p>
            <Button class="button mt-4" aria-label="close" @click="hideModal()" text="Ok"/>
        </div>
    </Modal>
</template>

<script>

import { Destination } from '@/utils/registration'
import Button from "@/views/components/ui/Button.vue";
import Modal from "@/views/components/ui/Modal.vue";

export default {
    name: 'RegisterStep0SelectDestination',
    components: {Modal, Button},
    emits: ['destinationSelected'],
    data: function() {
        return {
            modalVisible: false,
            modalText: '',
        }
    },
    methods: {
        selectWork() {
            this.$emit('destinationSelected', Destination.Work);
        },
        selectHome() {
            this.$emit('destinationSelected', Destination.Home);
        },
        selectSchool() {
            this.showModal(
                'Vielen Dank für Ihr Interesse an der Schulverpflegung durch gourmetta. Die Registrierung für ' +
                'Ihre Schule erfolgt ausschließlich über einen individuellen QR-Code, den Sie im Sekretariat oder ' +
                'in der Cafeteria/Mensa Ihrer Schule erhalten.'
            );
        },
        selectKita() {
            this.showModal(
                'Vielen Dank für Ihr Interesse an der Kita-Verpflegung durch gourmetta. Die Registrierung ' +
                'erfolgt ausschließlich über einen individuellen QR-Code, den Sie direkt bei der Kitaleitung Ihrer ' +
                'Einrichtung erhalten.'
            )
        },
        showModal(text) {
            this.modalText = text;
            this.modalVisible = true;
        },
        hideModal() {
            this.modalVisible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
ul {
    border-top: 1px solid $middle-light-grey;

    li {
        font-weight: $font-weight-bold;
        cursor: pointer;
        padding: .7rem 0;
        border-bottom: 1px solid $middle-light-grey;
        position: relative;

        &:after {
            border: 1px solid $primary;
            border-right: 0;
            border-top: 0;
            content: " ";
            display: block;
            height: 0.4em;
            margin-top: -1em;
            position: absolute;
            transform: rotate(225deg);
            width: 0.4em;
            cursor: pointer;
            right: 0;
        }
    }
}
</style>
